if(!customElements.get('material-select')) {
  class MaterialSelect extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.ul = this.querySelector('ul');
      this.a = this.querySelectorAll('a');
      this.options = Array.from(this.a);
      this.isOpen = false;
    }

    setActiveDescendant(option) {
      // Clear the previous keyboard highlight (kept separate from the
      // selected `.is-active` state so we don't touch the CSS file).
      this.options.forEach(o => o.style.removeProperty('background-color'));

      this.activeOption = option || null;

      if(this.activeOption) {
        if(this.activeOption.id) {
          this.setAttribute('aria-activedescendant', this.activeOption.id);
        }
        this.activeOption.style.backgroundColor = '#e6e6e6';
        if(typeof this.activeOption.scrollIntoView === 'function') {
          this.activeOption.scrollIntoView({ block: 'nearest' });
        }
      } else {
        this.removeAttribute('aria-activedescendant');
      }
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-expanded', 'false');
      this.setActiveDescendant(null);

      window.setTimeout(() => {
        const field = this.closest('material-field');
        this.classList.toggle('is-filled', this.input.value != '');
        field.classList.toggle('has-error', this.input.value == '');
        if(this.input.value && this.input.value != '') field.removeErrorMessage();
        if(!this.input.value || this.input.value == '') field.addErrorMessage();
      }, 0);

      this.isOpen = false;
    }

    open() {
      this.classList.add('is-open');
      this.setAttribute('aria-expanded', 'true');
      const active = this.querySelector('a.is-active') || this.options[0];
      this.setActiveDescendant(active);
      this.isOpen = true;
    }

    toggle(event) {
      event.preventDefault();
      event.stopPropagation();
      return this.isOpen ? this.close() : this.open();
    }

    select(a) {
      const active = this.querySelector('.is-active');
      if(active) {
        active.classList.remove('is-active');
        active.setAttribute('aria-selected', 'false');
      }
      a.classList.add('is-active');
      a.setAttribute('aria-selected', 'true');
      this.input.setAttribute('value', a.dataset.value);
      this.close();
      this.focus();
    }

    moveActive(step) {
      if(!this.options.length) return;
      const current = this.activeOption ? this.options.indexOf(this.activeOption) : -1;
      let next = current + step;
      if(next < 0) next = 0;
      if(next > this.options.length - 1) next = this.options.length - 1;
      this.setActiveDescendant(this.options[next]);
    }

    onKeydown(event) {
      switch(event.key) {
        case 'Enter':
        case ' ':
        case 'Spacebar':
          event.preventDefault();
          if(this.isOpen && this.activeOption) {
            this.select(this.activeOption);
          } else {
            this.open();
          }
          break;
        case 'ArrowDown':
          event.preventDefault();
          if(!this.isOpen) {
            this.open();
          } else {
            this.moveActive(1);
          }
          break;
        case 'ArrowUp':
          event.preventDefault();
          if(!this.isOpen) {
            this.open();
          } else {
            this.moveActive(-1);
          }
          break;
        case 'Home':
          if(this.isOpen) {
            event.preventDefault();
            this.setActiveDescendant(this.options[0]);
          }
          break;
        case 'End':
          if(this.isOpen) {
            event.preventDefault();
            this.setActiveDescendant(this.options[this.options.length - 1]);
          }
          break;
        case 'Escape':
          if(this.isOpen) {
            event.preventDefault();
            this.close();
            this.focus();
          }
          break;
        case 'Tab':
          if(this.isOpen) this.close();
          break;
      }
    }

    connectedCallback() {
      this.addEventListener('click', (e) => this.toggle(e));
      this.addEventListener('keydown', (e) => this.onKeydown(e));
      document.body.addEventListener('click', (e) => this.close(e));

      this.a.forEach(a => {
        a.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.select(a);
        });
      });
    }
  }

  customElements.define('material-select', MaterialSelect);
}
